import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { change, Field, getFormValues, reduxForm } from 'redux-form/immutable';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';

import { renderFieldSelect, renderFieldText } from '../Form/renderField';
import { v_required, v_province_length, n_cap_length, n_province, n_general, n_street_number_length, n_plate_length, v_cf_2, n_cf_length } from '../Form/checkField';
import FormButton from '../FormButton';
import CustomModal from '../../components/CustomModal';
import DataValue from '../../components/DataValue';
import HelpChat from '../../components/HelpChat';
import { Element } from '../../utils/scroll';
import NormalizeAddressForm from './NormalizeAddressForm';

import { postelURL } from '../../utils/fetch/axios';
import { updatedFetch } from '../../utils/fetch/actionCreators';
import { onSubmitFail, geolocate } from '../../utils/commonFormsHandlers';
import {
	HELPER_TIMEOUT
} from '../../utils/commonFormsConfig';
import { getCountries } from '../Step2/utils';
import { FORM_STEP3, goToNextStep } from '../Form/actionCreator';

import { getFetchAuth } from '../../components/HeaderLogin/selectors';
import { getHasProfile } from '../App/selectors';


class Step3 extends Component {
	state = {
		isOpen: false,
		openHelpChat: false,
		loading: false
	};

	componentDidMount() {
		setTimeout(() => {
			this.setState({ openHelpChat: true });
		}, HELPER_TIMEOUT);
	}

	handleMobilePhoneSelect = (prefix) => {
		const { change } = this.props;
		change('mobilePhone1Prefix', prefix);
	};

	handlePhoneSelect = (prefix) => {
		const { change } = this.props;
		change('phone1Prefix', prefix);
	};

	setAddress = (address) => {
		const { change } = this.props;

		change('address', address.indirizzo);
		change('numeroCivico', address.civico);
		change('frazione', address.frazione);
		change('citta', address.comune);
		change('provincia', address.provincia);
		change('cap', address.cap);
	}

	saveNormalizedAddress = () => {
		const { addresses } = this.state;
		const { goToNextStep, normalizeAddressFormValues } = this.props;

		const index = normalizeAddressFormValues?.toJS().n_address;
		this.setAddress(addresses[index]);

		goToNextStep();
	};

	render() {
		const {
			handleSubmit,
			change,
			valuesStep3,
			goToNextStep,
			hasProfile,
			t
		} = this.props;

		const { isOpen, openHelpChat, loading, addresses, validity } = this.state;

		const values = valuesStep3 ? valuesStep3.toJS() : {};
		const isCountryIT = values.nazione ? values.nazione.value === 'IT' : false;

		const countries = getCountries(t);

		return <div className='px-lg-4'>
			<form onSubmit={handleSubmit(() => {
				if (!hasProfile && isCountryIT) {
					const { updatedFetch, fetchAuth } = this.props;
					const params = {
						indirizzo: values.address,
						civico: values.numeroCivico,
						localita: values.citta,
						provincia: values.provincia,
						cap: values.cap
					};

					if (values.frazione) {
						params.localitaAggiuntiva = values.frazione;
					}

					this.setState({ loading: true }, () => {
						updatedFetch('GET', postelURL + '/address/normalize', params, [], [], [], fetchAuth).then((response) => {
							this.setState({ addresses: response.candidati, validity: response.validity, loading: false }, () => {
								const { addresses, validity } = this.state;
								if (validity === 1 && addresses.length > 0) {
									const normAddress = addresses[0];
									if (
										values.address.toUpperCase() !== normAddress.indirizzo.toUpperCase() ||
										values.numeroCivico.toUpperCase() !== normAddress.civico.toUpperCase() ||
										values.citta.toUpperCase() !== normAddress.comune.toUpperCase() ||
										(values.frazione && values.frazione.toUpperCase() !== normAddress.frazione.toUpperCase()) ||
										values.provincia.toUpperCase() !== normAddress.provincia.toUpperCase() ||
										values.cap.toUpperCase() !== normAddress.cap.toUpperCase()
									) {
										this.setState({ isOpen: true });
									} else {
										this.setAddress(normAddress);
										goToNextStep();
									}
								}

								if (validity === 2 || validity === 3) {
									this.setState({ isOpen: true });
								}
							});
						})
							.catch(() => this.setState({ loading: false }));
					});
				} else {
					goToNextStep();
				}
			})} noValidate autoComplete='off'>
				<div className='row'>
					<div className='form-group col-md-8 position-relative'>
						<Element name='address'></Element>
						{
							hasProfile ? <Fragment>
								<label>{t('form.step3.address')}</label>
								<DataValue value={values.address}></DataValue>
							</Fragment> :
								<Field name='address' label={t('form.step3.address')} component={renderFieldText} focus={() => geolocate(change, false, t)} autocomplete={false} required={true} validate={[(value) => v_required(value, t)]} />
						}
					</div>
					<div className='form-group col-md-4'>
						{
							hasProfile ? <Fragment>
								<label>{t('form.step3.numeroCivico')}</label>
								<DataValue value={values.numeroCivico}></DataValue>
							</Fragment> :
								<Field name='numeroCivico' label={t('form.step3.numeroCivico')} component={renderFieldText} required={true} validate={[(value) => v_required(value, t)]} normalize={n_street_number_length} />
						}
					</div>
					<div className='form-group col-md-6'>
						{
							hasProfile ? <Fragment>
								<label>{t('form.step3.frazione')}</label>
								<DataValue value={values.frazione}></DataValue>
							</Fragment> :
								<Field name='frazione' label={t('form.step3.frazione')} component={renderFieldText} normalize={n_general} />
						}
					</div>
					<div className='form-group col-md-6'>
						{
							hasProfile ? <Fragment>
								<label>{t('form.step3.citta')}</label>
								<DataValue value={values.citta}></DataValue>
							</Fragment> :
								<Field name='citta' label={t('form.step3.citta')} component={renderFieldText} required={true} validate={[(value) => v_required(value, t)]} normalize={n_general} />
						}
					</div>
					<div className='form-group col-md-6'>
						{
							hasProfile ? <Fragment>
								<label>{t('form.step3.provincia')}</label>
								<DataValue value={values.provincia}></DataValue>
							</Fragment> :
								<Field name='provincia' label={t('form.step3.provincia')} component={renderFieldText} required={isCountryIT} validate={isCountryIT ? [(value) => v_required(value, t), (value) => v_province_length(value, t)] : []} normalize={isCountryIT ? n_province : (value) => value} />
						}
					</div>
					<div className='form-group col-md-6'>
						{
							hasProfile ? <Fragment>
								<label>{t('form.step3.cap')}</label>
								<DataValue value={values.cap}></DataValue>
							</Fragment> :
								<Field name='cap' label={t('form.step3.cap')} component={renderFieldText} required={true} validate={[(value) => v_required(value, t)]} normalize={n_cap_length} />
						}
					</div>

				</div>
				<div className='row'>
					<div className='form-group col-md-6'>
						{
							hasProfile ? <Fragment>
								<label>{t('form.step3.nazione')}</label>
								<DataValue value={values.nazione ? values.nazione.label : ''}></DataValue>
							</Fragment> :
								<Field name='nazione' label={t('form.step3.nazione')} component={renderFieldSelect} options={countries} required={true} validate={[(value) => v_required(value, t)]} />
						}
					</div>
					{
						isCountryIT ? <div className='form-group col-md-6 mb-4'>
							{
								hasProfile ? <Fragment>
									<label>{t('form.step3.codiceFiscale')}</label>
									<DataValue value={values.codiceFiscale}></DataValue>
								</Fragment> :
									<Field name='codiceFiscale' label={t('form.step3.codiceFiscale')} component={renderFieldText} required={true} validate={[(value) => v_required(value, t), (value) => v_cf_2(value, t)]} normalize={n_cf_length} />
							}
						</div> : ''
					}
				</div>
				<div className='row'>
					<div className='form-group col-md-6'>
						<Field name='targaVeicolo' label={t('form.step3.targaVeicolo')} component={renderFieldText} required={true} validate={[(value) => v_required(value, t)]} normalize={n_plate_length} />
					</div>
					<div className='form-group col-md-6'>
						<Field name='modelloVeicolo' label={t('form.step3.modelloVeicolo')} component={renderFieldText} normalize={n_general} />
					</div>
				</div>
				<FormButton {...this.props} stopNext={loading}></FormButton>
			</form>
			{openHelpChat && <HelpChat />}
			<CustomModal
				className="address-normalize"
				isOpen={isOpen}
				currentTitle={validity === 1 ? t('form.step3.normalize.wrong.title') : validity === 3 ? t('form.step3.normalize.multiple.title') : t('form.step3.normalize.error.title')}
				currentContent={<NormalizeAddressForm addresses={addresses} validity={validity} t={t} />}
				buttons={<Fragment>
					{validity === 1 && <button className='btn btn-sm btn-primary my-2' onClick={() => {
						const { addresses } = this.state;
						const { goToNextStep } = this.props;

						this.setAddress(addresses[0]);
						goToNextStep();
					}}>{t('form.step3.normalize.wrong.button')}</button>}
					{validity === 3 && <button className='btn btn-sm btn-primary my-2' onClick={this.saveNormalizedAddress}>{t('form.step3.normalize.multiple.button')}</button>}
				</Fragment>}
				hideModal={() => this.setState({ isOpen: false })}
			/>
		</div>;
	}
}

const defaultValues = {
	mobilePhone1Prefix: '+39',
	phone1Prefix: '+39'
};

const mapStateToProps = (state) => {
	return {
		initialValues: defaultValues,
		valuesStep3: getFormValues(FORM_STEP3)(state),
		normalizeAddressFormValues: getFormValues('normalize_address_form')(state),
		hasProfile: getHasProfile(state),
		fetchAuth: getFetchAuth(state)
	};
};

const mapDispatchToProps = {
	change,
	goToNextStep,
	updatedFetch
};

Step3.propTypes = {
	initialValues: PropTypes.object,
	valuesStep3: PropTypes.object,
	normalizeAddressFormValues: PropTypes.object,
	change: PropTypes.func,
	handleSubmit: PropTypes.func,

	goToNextStep: PropTypes.func,
	hasProfile: PropTypes.bool,

	updatedFetch: PropTypes.func,
	fetchAuth: PropTypes.object,

	i18n: PropTypes.object,
	t: PropTypes.func
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(reduxForm({
	form: FORM_STEP3, // a unique name for this form
	destroyOnUnmount: false,
	onSubmitFail: (errors) => {
		onSubmitFail(errors);
	},
	// keepDirtyOnReinitialize: true,
	// enableReinitialize: true
	// validate,   // <--- validation function given to redux-form
	// warn        // <--- warning function given to redux-form
})(Step3)));
